import { createSlice } from '@reduxjs/toolkit';

const name = 'drawer';

export type State = {
  isOpen: boolean;
};

const initialState: State = {
  isOpen: false
};

const drawer = createSlice({
  name,
  initialState,
  reducers: {
    openDrawer: state => {
      state.isOpen = true;
    },
    closeDrawer: state => {
      state.isOpen = false;
    }
  }
});

export const { reducer: drawerReducer, actions: drawerAction } = drawer;
